import React from 'react';
import { ListItem } from '@andes/list';
import { quantityListItemPropTypes } from '../model';

const QuantityListItem = ({
  index,
  offsetIndex,
  localQuantity,
  quantitySelector,
  onClickListItem,
  closeTooltip,
  title,
}) => {
  const restProps = {};
  if (index === localQuantity) {
    restProps['data-autofocus'] = true;
  }

  return (
    <ListItem
      key={`list-item-quantity-${index}`}
      selected={offsetIndex === localQuantity}
      disabled={index > quantitySelector.available_quantity}
      onClick={event => onClickListItem({ event, quantity: offsetIndex, selected: localQuantity })}
      title={title}
      tabIndex={0}
      value={`${offsetIndex}`}
      {...restProps}
      onKeyUp={closeTooltip}
    />
  );
};

QuantityListItem.propTypes = quantityListItemPropTypes;
QuantityListItem.displayName = 'ListItem';
export default QuantityListItem;
